<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Products',

    metaInfo: { title: 'Products' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'products',
        'contact-us',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'products',
      },
    },
  }
</script>
